// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"256":"component---src-pages-404-jsx","351":"commons","400":"component---src-templates-post-jsx","678":"component---src-pages-index-js"}[chunkId] + "-" + {"256":"37b5f2d769351575276f","351":"08d17a6f76b3431d35d5","400":"a116e6bd05c13316d7bf","678":"360f05b2ea011dc306c0"}[chunkId] + ".js";
};